import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function FavoritesIcon({
	width = 17,
	height = 22,
	color = 'currentColor',
	style,
	...rest
}: IconRenderProps): ReactElement {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 17 22"
			fill="none"
			aria-hidden="true"
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<path d="M1.4308 1H16V21L8.5 13.451L1 21V1H1.4308Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
		</svg>
	);
}
